/**
 * Shared dive certification options for profile and guest booking forms.
 * Canonical values must stay in sync across both flows (prefill + Select matching).
 */

export const CERTIFICATE_LEVELS = [
  'Open Water',
  'Advanced Open Water',
  'Rescue Diver',
  'Dive Master',
] as const;

export type CertificateLevel = (typeof CERTIFICATE_LEVELS)[number];

export const CERTIFYING_AGENCIES = [
  'PADI',
  'SSI',
  'NAUI',
  'CMAS',
  'BSAC',
  'SDI',
  'TDI',
  'IANTD',
  'ANDI',
  'YMCA',
  'NASDS',
  'PDIC',
] as const;

export type CertifyingAgency = (typeof CERTIFYING_AGENCIES)[number];

/** Legacy spellings stored before profile/guest enums were aligned. */
const CERTIFICATE_LEVEL_ALIASES: Record<string, CertificateLevel> = {
  Divemaster: 'Dive Master',
  DiveMaster: 'Dive Master',
  'dive master': 'Dive Master',
};

export const normalizeCertificateLevel = (
  level: string | null | undefined,
): string => {
  if (!level) {
    return '';
  }
  const trimmed = level.trim();
  return CERTIFICATE_LEVEL_ALIASES[trimmed] ?? trimmed;
};

export const normalizeCertifyingAgency = (
  agency: string | null | undefined,
): string => {
  if (!agency) {
    return '';
  }
  const trimmed = agency.trim();
  const match = CERTIFYING_AGENCIES.find(
    option => option.toLowerCase() === trimmed.toLowerCase(),
  );
  return match ?? trimmed;
};
